
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.72968 6.74868V9.10875H8V11.9944H9.72968V20.5707H13.2801V11.9953H15.6633C15.6633 11.9953 15.8866 10.6117 15.9948 9.09844H13.2947V7.12485C13.2947 6.83027 13.6812 6.43349 14.0642 6.43349H16V3.42931H13.3685C9.64122 3.42931 9.72968 6.31755 9.72968 6.74868Z","fill":"#16171F"}})])
          )
        }
      }
    